import React, { useEffect, useMemo, useState, useContext } from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { USER_ROLES } from "constants";

import Row from "components/common/Row";
import Column from "components/common/Column";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { MissionContext } from "modules/pvs_activities/components/contexts/MissionTasksContext";
import MissionDelegate from "modules/pvs_activities/components/mission/MissionDelegate";
import MissionContactPerson from "modules/pvs_activities/components/mission/MissionContactPerson";
import MissionProxyDelegate from "modules/pvs_activities/components/mission/MissionProxyDelegate";
import UserInformationCard from "modules/pvs_activities/components/mission/UserInformationCard";
import MissionCC from "modules/pvs_activities/components/mission/MissionCC";
import MissionExpertSets from "modules/pvs_activities/components/mission/MissionExpertSets";
import MissionManagerModal from "modules/pvs_activities/components/Modal/MissionManagerModal";
import { generateOptionsFromData, sendAPIRequest } from "helpers";
import ReportShowButton from "modules/pvs_activities/components/mission/ReportShowButton";
import Button from "components/common/Button";


const MissionConfiguration = ({ config }) => {
    const missionContext = useContext(MissionContext);
    const authData = useSelector(s => s.auth.data);
    const [refreshMissionCC, setRefreshMissionCC] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { id } = useParams();
    const [isShow1, setIsShow1] = useState(false);
    const [userData, setUserData] = useState([]);

    const initModal1 = () => {
        setIsShow1(!isShow1);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        loadUserData();
    }, []);

    const userOptions = useMemo(() => {
        return generateOptionsFromData(userData, {
            value: "id",
            label: "name",
        });
    }, [userData]);

    const loadUserData = async () => {
        try {
            const ret = await sendAPIRequest(`/api/users/?role_id=3`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setUserData(res.data);
            }
        } catch (err) {
            console.log({ err });
        }
    };

    const canChangeMissionManager = () => {
        if (
            USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
            USER_ROLES.it_admin.includes(parseInt(authData?.role_id))
        ) {
            return true;
        }
    }

    const canChangeMissionDelegate = () => {
        return false;
    }

    const canChangeMissionProxyDelgate = () => {
        if (
            USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
            USER_ROLES.it_admin.includes(parseInt(authData?.role_id)) ||
            missionContext.missionManager === parseInt(authData?.id) ||
            missionContext.missionDelegate === parseInt(authData?.id)
        ) {
            return true;
        }
    }

    const canChangeMissionContactPerson = () => {
        if (
            USER_ROLES.business_admin.includes(authData?.role_id) ||
            USER_ROLES.it_admin.includes(authData?.role_id) ||
            missionContext.missionManager === parseInt(authData?.id) ||
            missionContext.missionDelegate === parseInt(authData?.id)
        ) {
            return true;
        }
    }

    const canChangeMissionActors = () => {
        if (
            USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
            USER_ROLES.it_admin.includes(parseInt(authData?.role_id)) ||
            missionContext.missionManager === parseInt(authData?.id)
        ) {
            return true;
        }
    }

    const handleMissionManagerSuccess = () => {
        setRefreshMissionCC((prev) => !prev);
    };

    const handleChangeSecurity = () => {
        navigate(`/portal/mission-process/${id}/changeform`)
    }

    return (
        <>

            <div className="container my-2">
            </div>
            <div className="my-2">
                <div className="pb-2">
                    <Row>
                        {
                            !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                            <Column col={6}>
                                <UserInformationCard
                                    cardHeaderText="Mission Manager"
                                    cardColor={"bg-light-3"}
                                    name={missionContext.missionData?.relationMissionManager?.name}
                                    email={missionContext.missionData?.relationMissionManager?.email}
                                    role={missionContext.missionData?.relationMissionManager?.role_name}
                                    status={"Assigned"}
                                    change={initModal1}
                                    buttonText={missionContext.missionData?.relationMissionManager === null ? "Assign" : "Change"}
                                    showButton={missionContext.is_archived ? false : canChangeMissionManager()}
                                    infoText={"Mission Manager is not assigned."}
                                />
                            </Column>
                        }
                        <Column col={6}>
                            <MissionDelegate canChangeMissionDelegate={canChangeMissionDelegate} />
                        </Column>
                        <Column className='my-2' col={6}>
                            <MissionContactPerson canChangeMissionContactPerson={canChangeMissionContactPerson} />
                        </Column>
                        <Column className='my-2' col={6}>
                            <MissionProxyDelegate canChangeMissionProxyDelgate={canChangeMissionProxyDelgate} />
                        </Column>
                        {
                            !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) && (<>
                                <Column className="py-2" col={6}>
                                    <ReportShowButton canChangeMissionProxyDelgate={canChangeMissionProxyDelgate} />
                                </Column>
                                <Column className="py-2" col={6}>
                                    <>
                                        <Card className={`bg-green-light-4 p-5 rounded-0 h-100`}>
                                            <h2>Is there any change in the mission?</h2>
                                            {!missionContext.is_archived && (<div className="bg-transparent border-0 text-left pt-14">
                                                <Button className="btn btn-outline rounded-5 p-2" onClick={handleChangeSecurity}>
                                                    Change
                                                </Button>
                                            </div>)}
                                        </Card>
                                    </>
                                </Column>
                            </>
                            )}
                    </Row>
                    {
                        !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                        <MissionCC missionID={missionContext?.missionData?.id} canChangeMissionActors={canChangeMissionActors} refresh={refreshMissionCC} />
                    }
                    {
                        !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                        <MissionExpertSets canModify={canChangeMissionActors()} />
                    }
                </div>
                {
                    !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
                    <MissionManagerModal
                        isShow={isShow1}
                        initModal={initModal1}
                        data={userOptions}
                        onSuccess={handleMissionManagerSuccess}
                    />
                }
            </div>
        </>
    )
};
export default MissionConfiguration;
